
    import CadastroInline from '@/components/aplicacao/CadastroInline.vue';    
    import Multiselect from '@vueform/multiselect'
    import BotaoSalvar from '@/components/aplicacao/BotaoSalvar.vue';
    import ListaCampoForm from '@/components/aplicacao/ListaCampoForm.vue';  
    import { Options  , Vue } from "vue-class-component";   
    import {  Perfil } from "./Perfil";
	import $ from "jquery" 
    import { PerfilConfig } from "@/core/config/PerfisConfig";
    import {  Prop   } from 'vue-property-decorator';  
    import   SiteUtils   from '@/assets/ts/aplicacao/site';
	  
    @Options({
        name: "PerfilCadastro",
        components: { CadastroInline  , Multiselect, ListaCampoForm, BotaoSalvar  },  
        emits: [  'perfil-cadastro-alterado'],  
    }) 
    export default class PerfilCadastro extends Vue {
          
        @Prop( ) readonly modal_cadastro!: any  
        @Prop( ) readonly perfis!: any 
        @Prop( ) readonly service!: any
          
        public modal = '';
        public editando = false;
        public processando = false;  
        public formulario: any  = { } ;   
        public campos: Array<any> = [ ];
   
        created() {  
            this.campos =  Perfil.campos();  
        }
   
        get hasPermissao(   ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ] ,  this.perfis); 
        }
   
        public getdados(){   
            let dados = JSON.parse(JSON.stringify(this.formulario));  
            return dados;
        }
 
        public sucesso(){  
            this.$emit("perfil-cadastro-alterado", null);     
            $("[data-bs-dismiss='modal']").trigger({ type: "click" });
        }

        
        public editar(){ 
            if( this.hasPermissao ){
                this.editando = !this.editando ;  
            }
            else {
                 this.editando = false ;
            } 
        }
 
        public salvar(){
            if( this.processando  ||  !this.hasPermissao ){
                return;
            }
            this.processando = true ;  
            let dados = this.getdados() ;  
            setTimeout(() => {  
                this.service.cadastrar(   dados )
                .then(response => { 
                    SiteUtils.toastSucesso('Cadastrado com sucesso! ' ,  response.message  );
                    this.sucesso();  
                    this.formulario = {};
                    this.processando = false ; 
                    this.editando = false ;
                }) 
                .catch(error => {
                    this.processando = false ;
                    SiteUtils.toastErro('Error! ' ,  error.data.message  );
                });  
            }, 100);
            
        } 

        
    } 
